module.exports = __webpack_public_path__ + "img/play-circle.e29bac72.svg";